import { render } from "./HR_Templates.vue?vue&type=template&id=6d59af90"
import script from "./HR_Templates.vue?vue&type=script&lang=js"
export * from "./HR_Templates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__